import { render, staticRenderFns } from "./BeeDropImg.vue?vue&type=template&id=3f4125d4"
import script from "./BeeDropImg.vue?vue&type=script&lang=js"
export * from "./BeeDropImg.vue?vue&type=script&lang=js"
import style0 from "./BeeDropImg.vue?vue&type=style&index=0&id=3f4125d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports